import React from "react";

const Terms = () => {
  return (
    <div className="container my-5">
      <h2>Terms of Use</h2>
      <p>
        Please read these Terms and Conditions ("Terms", "Terms and Conditions")
        carefully before using the ToGoWith application and (the "Service")
        operated by Dutiap inc. located at 651 N. Broad St. suite 206,
        Middletown, DE 190709 ("us", "we", or "our").
      </p>
      <p>
        Your access to and use of the Service is conditioned upon your
        acceptance of and compliance with these Terms. These Terms apply to all
        visitors, users and others who wish to access or use the Service.
      </p>
      <p>
        By creating a Service account, you agree to these Terms of use and
        Privacy Policy. If you disagree with any part of the terms, then you do
        not have permission to access the Service.
      </p>
      <h5>1. Services</h5>
      <p>
        Service is a service that facilitates communication between mutually
        interested users. Users use left or right swipes to “like” or
        “dislike” photos of other users and potentially match with them. Users
        can also rate photos of other users.
      </p>
      <p>
        Chatting on Service is only available between two users who have swiped
        right on one another's photos and matched.
      </p>
      <h5>2. Account creation</h5>
      <p>
        To use the Service, you need to create an account.
        <br />
        You are responsible for maintaining the confidentiality of your Service
        login credentials and for all activities that occur under those
        credentials.
        <br />
        If you think someone has gained access to your account, please
        immediately contact us via support@togowith.com.
      </p>
      <h5>3. Eligibility</h5>
      <p>
        You must be at least 18 years of age to create an account on the Service
        and use the Service.
        <br />
        By creating an account and using the Service, you warrant that you have
        never been convicted of a felony or indictable offense, a sex crime or
        any crime involving violence, and that you are not required to register
        as a sex offender with any state, federal or local sex offender
        registry.
      </p>
      <h5>4. Community rules</h5>
      <p>
        Being a part of Service community, you shall not:
        <ul>
          <li>post any Content that objectifies real people;</li>
          <li>
            post any Content that violates or infringes anyone's rights,
            including rights of publicity, privacy, copyright, trademark or
            other intellectual property or contract right;
          </li>
          <li>
            post any Content that is hate speech, threatening, sexually explicit
            or pornographic;
          </li>
          <li>
            post any Content that promotes violence, racism, bigotry, hatred or
            physical harm of any kind against any group or individual;
          </li>
          <li>
            use another member's account, share an account with another member
            or maintain more than one account;
          </li>
          <li>
            create another account if we have already terminated your account,
            unless you have our permission.
          </li>
        </ul>
        In case of violation, your account may be blocked and you may be
        reported to the authorities for any illegal actions.
      </p>
      <h5>5. Safety rules</h5>
      <p>
        We encourage a respectful member experience through features like the
        double opt-in (when both users swipe right) that allows members to
        communicate only after they have both indicated interest in one another.
        <br />
        It is not responsible for the conduct of any member on or off of the
        Service.
        <br />
        You agree to use caution in all interactions with other members,
        particularly if you decide to communicate off the Service or meet in
        person.
        <br />
        You agree that you will not provide your financial information (for
        example, your credit card or bank account information), or wire or
        otherwise send money, to other members.
      </p>
      <h5>6. Your rights and obligations</h5>
      <p>
        Any software that we provide, you may automatically download and install
        upgrades, updates, or other new features. You may be able to adjust
        these automatic downloads through your device's settings.
        <br />
        When communicating with our customer care representatives, you agree to
        be respectful and kind. If we feel that your behavior towards any of our
        customer care representatives or other employees is at any time
        threatening or offensive, we reserve the right to immediately terminate
        your account.
        <br />
        You shall not, directly or indirectly:
      </p>
      <ul>
        <li>
          reverse engineer, decompile, disassemble or otherwise attempt to
          discover the source code, object code or underlying structure, ideas,
          know-how or algorithms relevant to the Services or any software,
          documentation or data related to the Services (“Software”);
        </li>
        <li>modify, translate, or create derivative works based on the Services or any Software;</li>
        <li>access all or any part of the Services or the Software, in order to build a product or service which competes with the Services;</li>
        <li>use the Services to provide services to third parties;</li>
        <li>license, sell, rent, lease, transfer, assign, distribute, display, disclose, or otherwise commercially exploit, or otherwise make the Services available to any third party;</li>
        <li>use the Services in a manner that is illegal or causes damage or injury to any person or property;</li>
        <li>access, store, distribute or use during the course of its use of the Services any malware or any material that is unlawful, harmful, threatening, defamatory, obscene, infringing, harassing or racially or ethnically offensive; facilitates illegal activity; depicts sexually explicit images; promotes unlawful violence; is discriminatory based on race, gender, color, religious belief, sexual orientation, disability;</li>
        <li>attempt to obtain, or assist third parties in obtaining, access to the Services.</li>
      </ul>
      <p>
        In consideration for Service allowing you to use the Service, you agree
        that we, our affiliates, and our third-party partners may place
        advertising on the Service.
      </p>
      <h5>7. Rights you Grant to us</h5>
      <p>
        By creating an account, you grant to Service a non-exclusive,
        worldwide, transferable, sub-licensable, royalty-free, right and
        license to host, store, use, copy, edit and publish information you
        authorize to us and the device you use to register and any information
        you post, upload, display or otherwise make available ("post") on the
        Service or transmit to other members ("Content").
        <br />
        You grant to Service an exclusive license with respect to derivative
        works created through use of the Service. For example, Service shall
        have an exclusive license to screenshots of the Service that include
        your Content.
        <br />
        You authorize Service to act on your behalf with respect to infringing
        uses of your Content taken from the Service by other members or third
        parties.
      </p>
      <h5>8. Content management</h5>
      <p>
        You agree that any Content you place or that you authorize us to place
        on the Service may be viewed by other members and may be viewed by any
        person visiting or participating in the Service.
        <br />
        You agree that all information that you submit upon creation of your
        account is accurate and truthful and you have the right to post the
        Content on the Service and grant the license to the Service.
        <br />
        You understand and agree that we may delete any Content, in whole or in
        part, that at our sole discretion violates these Terms or may harm the
        reputation of the Service.
        <br />
        We may access, store and disclose your account information and Content
        if required to do so by law, by performing its agreement with you, or in
        a good faith belief that such access, storage or disclosure satisfies a
        legitimate interest, including to:
      </p>
      <ul>
        <li>comply with legal process;</li>
        <li>enforce the Terms;</li>
        <li>respond to claims that any Content violates the rights of third parties;</li>
        <li>respond to your requests for customer service; or</li>
        <li>protect the rights, property or personal safety of the Company or any other person.</li>
      </ul>
      <h5>9. Copyright Policy</h5>
      <p>
        We respect the intellectual property rights of others. It is our policy
        to respond to any claim that Content posted on the Service infringes on
        the copyright or other intellectual property rights ("Infringement") of
        any person or entity.
        <br />
        If you are a copyright owner, or authorized on behalf of one, and you
        believe that the copyrighted work has been copied in a way that
        constitutes copyright infringement, please submit your claim via email
        with the subject line: "Copyright Infringement" and include in your
        claim a detailed description of the alleged Infringement.
        <br />
        You may be held accountable for damages (including costs and attorneys'
        fees) for misrepresentation or bad-faith claims on the infringement of
        any Content found on and/or through the Service of your copyright.
      </p>
      <h5>10. Intellectual Property</h5>
      <p>
        The Service and its original content (excluding Content provided by
        users), features and functionality are and will remain the exclusive
        property of Dutiap inc. and its licensors.
        <br />
        The Service is protected by copyright, trademark, and other laws around
        the world. Our trademarks and trade dress may not be used in connection
        with any product or service without our prior written consent.
      </p>
      <h5>11. Links to Other Websites</h5>
      <p>
        Our Service may contain links to third party websites or services that
        are not owned or controlled by us.
        <br />
        We have no control over, and assume no responsibility for the content,
        privacy policies, or practices of any third party websites or services.
        We do not warrant the offerings of these entities/individuals or their
        websites.
        <br />
        You acknowledge and agree that we are not responsible or liable, directly
        or indirectly, for any damage or loss caused or alleged to be caused by
        or in connection with use of or reliance on any such content, goods or
        services available on or through any such third party websites or
        services.
        <br />
        We strongly advise you to read the terms and conditions and privacy
        policies of any third party websites or services that you visit.
      </p>
      <h5>12. Modifying the Service</h5>
      <p>
        We are always striving to improve the Service and bring you additional
        functionality that you will find useful. This means we may add new
        product features or enhancements from time to time as well as remove
        some features.
        <br />
        If these actions do not materially affect your rights or obligations, we
        may not provide you with notice before taking them.
        <br />
        We may suspend the Service entirely. In this case we will notify you in
        advance unless safety or security concerns prevent us from doing so.
      </p>
      <h5>13. Termination</h5>
      <p>
        You may terminate your account at any time, for any reason, by following
        the Service instructions.
        <br />
        We may terminate your account at any time, without prior notice or
        liability if we believe your actions do not match the provisions of
        these Terms or other policies, or your actions cause harm to the
        Service.
        <br />
        All provisions of the Terms which by their nature should survive
        termination shall survive termination, including, without limitation,
        ownership provisions, warranty disclaimers, indemnity and limitations of
        liability.
      </p>
      <h5>14. Indemnification</h5>
      <p>
        You agree to defend, indemnify and hold us harmless and our licensee and
        licensors, and their employees, contractors, agents, officers and
        directors, from and against any and all claims, damages, obligations,
        losses, liabilities, costs or debt, and expenses (including but not
        limited to attorney's fees), resulting from or arising out of your use
        and access of the Service or a breach of these Terms.
      </p>
      <h5>15. Limitation of Liability</h5>
      <p>
        In no event shall our company, nor its directors, employees, partners,
        agents, suppliers, or affiliates, be liable for any indirect,
        incidental, special, consequential or punitive damages, including,
        without limitation, loss of profits, data, use, goodwill, or other
        intangible losses, resulting from:
      </p>
      <ul>
        <li>your access to or use of or inability to access or use the Service;</li>
        <li>any conduct or content of any third party on the Service;</li>
        <li>any content obtained from the Service; and</li>
        <li>unauthorized access, use or alteration of your transmissions or content.</li>
      </ul>
      <p>
        whether based on warranty, contract, tort (including negligence) or any
        other legal theory, whether we have been informed of the possibility of
        such damage, and even if a remedy set forth herein is found to have
        failed of its essential purpose.
      </p>
      <h5>16. Disclaimer</h5>
      <p>
        Your use of the Service is at your sole risk. The Service is provided on
        an "AS IS" and "AS AVAILABLE" basis. The Service is provided without
        warranties of any kind, whether express or implied, including, but not
        limited to, implied warranties of merchantability, fitness for a
        particular purpose, non-infringement or course of performance.
        <br />
        Our company, subsidiaries, affiliates and its licensors do not warrant
        that:
      </p>
      <ul>
        <li>the Service will function uninterrupted, secure or available at any particular time or location;</li>
        <li>any errors or defects will be corrected;</li>
        <li>the Service is free of viruses or other harmful components; or</li>
        <li>the results of using the Service will meet your requirements.</li>
      </ul>
      <h5>17. Exclusions</h5>
      <p>
        Some jurisdictions do not allow the exclusion of certain warranties or
        the exclusion or limitation of liability for consequential or incidental
        damages, so the limitations above may not apply to you.
      </p>
      <h5>18. Except for members residing within the EU or European Economic Area and elsewhere where prohibited by applicable law:</h5>
      <p>
        The exclusive means of resolving any dispute or claim arising out of or
        relating to this Agreement (including any alleged breach thereof) or the
        Service shall be binding administered by JAMS under the JAMS Streamlined
        Arbitration Rules &amp; Procedures.
        <br />
        The one exception to the exclusivity of arbitration is that either party
        has the right to bring an individual claim against the other in a small
        claims court of competent jurisdiction, or, if filed in arbitration, the
        responding party may request that the dispute proceed in small claims
        court instead if the claim is within the jurisdiction of the small
        claims court.
        <br />
        If the request to proceed in small claims court is made before an
        arbitrator has been appointed, the arbitration shall be administratively
        closed. If the request to proceed in small claims court is made after an
        arbitrator has been appointed, the arbitrator shall determine whether
        the dispute should remain in arbitration or instead be decided in small
        claims court.
        <br />
        Such arbitration shall be conducted by written submissions only, unless
        either you or Service elect to invoke the right to an oral hearing
        before the Arbitrator.
        <br />
        But whether you choose arbitration or small claims court, you agree that
        you will not under any circumstances commence, or maintain, or
        participate in against the Company any class action, class arbitration,
        or other representative action or proceeding against the Service.
        <br />
        By using the Service in any manner, you agree to the above arbitration
        agreement. In doing so, you give up your right to go to court to assert
        or defend any claims between you and the Company (except for matters
        that may be taken to small-claims court). You also give up your right to
        participate in a class action or other class proceeding.
        <br />
        If you assert a claim against Service outside of small claims court (and
        Service does not request that the claim be moved to small claims court),
        your rights will be determined by a neutral arbitrator, not a judge or
        jury, and the arbitrator shall determine all claims and all issues
        regarding the arbitrability of the dispute.
        <br />
        You are entitled to a fair hearing before the arbitrator. The arbitrator
        can generally grant any relief that a court can, including the ability
        to hear a dispositive motion (which may include a dispositive motion
        based upon the parties’ pleadings, as well as a dispositive motion based
        upon the parties’ pleadings, along with the evidence submitted), but you
        should note that arbitration proceedings are usually simpler and more
        streamlined than trials and other judicial proceedings. Decisions by the
        arbitrator are enforceable in court and may be overturned by a court
        only for very limited reasons.
        <br />
        Any proceeding to enforce this arbitration agreement, including any
        proceeding to confirm, modify, or vacate an arbitration award, may be
        commenced in any court of competent jurisdiction. In the event that this
        arbitration agreement is for any reason held to be unenforceable, any
        litigation against the Company (except for small-claims court actions)
        may be commenced only in the federal or state courts of Delaware. You
        hereby irrevocably consent to the jurisdiction of those courts for such
        purposes.
        <br />
        The online dispute settlement platform of the European Commission is
        available under{" "}
        <a href="http://ec.europa.eu/odr" target="_blank" rel="noreferrer">
          http://ec.europa.eu/odr
        </a>. ToGoWith does not take part in dispute settlement procedures in front
        of a consumer arbitration entity for members residing in the EU or
        European Economic Area.
      </p>
      <h5>19. Governing Law</h5>
      <p>
        For members residing in the EU or European Economic Area or elsewhere
        where our arbitration agreement is prohibited by law, the laws of
        Delaware, U.S.A., excluding Delaware’s conflict of laws rules, will
        apply to any disputes arising out of or relating to this Agreement or
        the Service. Notwithstanding the foregoing, the Arbitration Agreement
        above shall be governed by the Federal Arbitration Act. For the
        avoidance of doubt, the choice of Delaware governing law shall not
        supersede any mandatory consumer protection legislation in such
        jurisdictions.
      </p>
      <h5>20. Venue</h5>
      <p>
        Except for members residing in the EU or European Economic Area who may
        bring claims in their country of residence in accordance with applicable
        law and except for claims that may be properly brought in a small claims
        court of competent jurisdiction, all claims arising out of or relating
        to this Agreement, to the Service, or to your relationship with Service
        that for whatever reason are not submitted to arbitration will be
        litigated exclusively in the federal or state courts of Delaware, U.S.A.
        You and Service consent to the exercise of personal jurisdiction of
        courts in the State of Delaware and waive any claim that such courts
        constitute an inconvenient forum.
      </p>
      <h5>21. General provisions</h5>
      <p>
        Our failure to enforce any right or provision of these Terms will not be
        considered a waiver of those rights. If any provision of these Terms is
        held to be invalid or unenforceable by a court, the remaining provisions
        of these Terms will remain in effect.
        <br />
        These Terms constitute the entire agreement between us regarding our
        Service, and supersede and replace any prior agreements we might have
        had between us regarding the Service.
      </p>
      <h5>22. Changes</h5>
      <p>
        We reserve the right, at our sole discretion, to modify or replace these
        Terms at any time.
        <br />
        If the changes take place, we will notify you at least 30 days in
        advance (unless we’re unable to do so under applicable law) by
        reasonable means.
        <br />
        If you continue to use the Service after the changes become effective,
        then you agree to the revised Agreement.
      </p>
      <h5>23. Contact Us</h5>
      <p>
        You may contact us regarding the Service or these Terms at:{" "}
        <a href="mailto:support@togowith.com">support@togowith.com</a>.
      </p>
    </div>
  );
};

export default Terms;
